export const FILE_MAX_SIZE: number = 20 * 1024 * 1024;
export const FILE_MAX_SIZE_MESSAGE: string = `Максимальный размер файла не должен превышать 20mb`;
export const SEND_FILE_MESSAGE_ERROR: string = `Произошла ошибка во время отправки файла`;
export const START_MESSAGE_TAG: string = 'START_MESSAGE_TAG';
export const CHAT_CLOSED_TAG: string = 'chat-closed';
export const CUSTOM_BUTTONS_STYLE_TAG: string = 'custom-buttons-style';
export const START_MESSAGE_HEADER: string = 'start-message';
export const MESSAGE_RESEND_ATTEMPTS: number = 8;